import {connect} from "react-redux";
import React, {Component} from "react";
import {
    delPaymentThunkCreator,
    getArticlesThunkCreator,
    postCarsExpensesThunkCreator,
    postIncomeThunkCreator,
    postOneExpensesThunkCreator,
    postOneIncomeThunkCreator,
    postOperExpensesThunkCreator,
    postPaymentThunkCreator,
    postRentExpensesThunkCreator,
    postStaffSalaryThunkCreator
} from "../../redux/reducers/financeReducer";
import {Spin} from 'antd';
import IncomeManagementWithErrorBoundary from "./components/IncomeManagementWithErrorBoundary";

class Finance extends Component {

    constructor(props) {
        super(props)
    }

    componentDidMount() {
        this.props.getArticlesThunkCreator()
    }

    render() {
        if (this.props.loading) {
            return <div className="example"><Spin/></div>
        } else {
            return (
                <IncomeManagementWithErrorBoundary income={this.props.income}
                                                   one_income={this.props.one_income}
                                                   objects={this.props.objects}
                                                   postIncome={this.props.postIncomeThunkCreator}
                                                   payments={this.props.payments}
                                                   postPayment={this.props.postPaymentThunkCreator}
                                                   postOneIncome={this.props.postOneIncomeThunkCreator}
                                                   delPayment={this.props.delPaymentThunkCreator}
                />
            )
        }
    }
}


const mapStateToProps = (state) => {


    return {
        articles_expenses: state.financeRDCR.articles_expenses,
        staff: state.financeRDCR.staff,
        salary: state.financeRDCR.salary,
        loading: state.financeRDCR.loading,
        cars: state.financeRDCR.cars,
        cars_expenses: state.financeRDCR.cars_expenses,
        rent_expenses: state.financeRDCR.rent_expenses,
        oper_expenses: state.financeRDCR.oper_expenses,
        income: state.financeRDCR.income,
        objects: state.financeRDCR.objects,
        one_expenses: state.financeRDCR.one_expenses,
        one_income: state.financeRDCR.one_income,
        payments: state.financeRDCR.payments,

    }
};


export default connect(mapStateToProps, {
    getArticlesThunkCreator,
    postStaffSalaryThunkCreator,
    postCarsExpensesThunkCreator,
    postRentExpensesThunkCreator,
    postOperExpensesThunkCreator,
    postIncomeThunkCreator,
    postOneExpensesThunkCreator,
    postPaymentThunkCreator,
    postOneIncomeThunkCreator,
    delPaymentThunkCreator
})(Finance);
